<template>
  <div class="profile-wrapper">
    <div class="page-name">Company Profile</div>
    <section class="card-sections">
      <p class="card-titles">Company Logo</p>
      <p class="sub-text">change your company logo that appears through out the app</p>
      <div class="upload-section">
        <img
          :src="userProfile.logo.lenght>0? userProfile.logo[0]:'/img/default-logo.png'"
          alt
          class="logo-img"
          v-if="userProfile"
        />
        <div class="us-right">
          <p class="sub-text">Images must be at least 200 x 200px</p>
          <div class="buttons-holder">
            <b-button @click="$bvModal.show('add-logo')" variant="info">Choose logo</b-button>
            <p class="remove-btn sub-text">Remove</p>
          </div>
        </div>
      </div>
    </section>
    <div class="details-section card-sections">
      <p class="card-titles">Company Details</p>
      <p class="sub-text">Company Name, Email, Phone Number, and Address</p>
      <validation-observer v-slot="{invalid}">
        <form action>
          <div class="form-row align-items-center">
            <div class="col-sm-3 my-1">
              <label class for="companyName">Company Name</label>
              <TextInput :rules="'required|companyName'" id="companyName" v-model="company.name" />
            </div>
          </div>
          <div class="form-row align-items-center">
            <div class="col-sm-3 my-1">
              <label class for="companySlug">Company Slug</label>
              <TextInput :disabled="true" id="companySlug" v-model="company.username" />
            </div>
          </div>
          <div class="form-row align-items-center">
            <div class="col-sm-3 my-1">
              <label class for="companyEmail">Email</label>
              <TextInput
                :rules="'required|email|companyEmail'"
                v-model="company.email"
                id="companyEmail"
                type="email"
              />
            </div>
          </div>
          <div class="form-row align-items-center">
            <div class="col-sm-3 my-1">
              <label class for="contactNumber">Contact Number</label>
              <TextInput
                :rules="'required'"
                v-model="company.number"
                id="contactNumber"
                type="number"
              />
            </div>
          </div>
          <div class="form-row align-items-center">
            <div class="col-sm-3 my-1">
              <label class for="companyAddress">Address</label>
              <TextInput
                :rules="'required'"
                v-model="company.address"
                id="companyAddress"
                type="text"
              />
            </div>
          </div>
          <Botton
            :isLoading="updatingCompany"
            :onclick="updateCompany"
            :disabled="invalid"
            text="Change"
            variant="info"
          />
        </form>
      </validation-observer>
    </div>
    <section class="password-section card-sections">
      <p class="card-titles">Change Password</p>
      <validation-observer v-slot="{invalid}">
        <div class="form-row align-self-start">
          <div class="col-sm-3 my-1 align-items-baseline">
            <label class for="newPassword">New Password</label>
            <TextInput
              :rules="{'regex':/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,'required':true}"
              vid="confirmation"
              name="confirmation"
              v-model="password.new"
              id="newPassword"
              type="password"
            />
          </div>
          <div class="col-sm-3 my-1 align-self-start">
            <label class for="confirmPassword">Confirm Password</label>
            <TextInput
              :rules="'required|confirmed:confirmation'"
              v-model="password.confirm"
              id="confirmPassword"
              type="password"
            />
          </div>

          <div class="col-sm-3 my-1 align-self-center">
            <Botton
              :isLoading="updatingPassword"
              :onclick="changePassword"
              :disabled="invalid"
              text="Change"
              variant="info"
            />
          </div>
        </div>
      </validation-observer>
      <div class="form-row align-items-end">
        <p
          class="sub-text"
        >* Must be at least 8 characters and include a number (0-9) and an uppercase letter (A-Z)</p>
      </div>
    </section>

    <section class="delete-account">
      <p class="da-title card-titles">Delete My Account</p>
      <p class="sub-text">Once deleted, your account cannot be reinstated.</p>
      <Botton buttonClass="delete-btn" text="Delete Account" variant="link" />
    </section>
    <b-modal @ok="changeLogo" v-if="userProfile" id="add-logo" size="sm" title="Change Logo">
      <FileUpload
        :onfile="fileChange"
        :value="file"
        :isLoading="fileLoading"
        @changed="fileChange($event)"
        label="upload background image"
        fileTypes="PNG up to 5MB"
        :progress="progress"
        :preview="previewURL(userProfile.logo,removeItems)"
        :deleteUrl="deleteUrl"
        :deleteFile="deleteFile"
        :max="1"
      />
    </b-modal>
  </div>
</template>
<script>
//import { Tabs, TabPane } from '@/components';
import Botton from "../pages/components/Botton";
import FileUpload from "../pages/components/DragDropFileInput";
import { FormGroupInput } from "@/components";
import TextInput from "./components/Inputs/TextInput";
import { ValidationObserver } from "vee-validate";

export default {
  name: "profile",
  bodyClass: "profile-page",
  components: {
    Botton,
    FileUpload,
    [FormGroupInput.name]: FormGroupInput,
    TextInput,
    ValidationObserver
  },
  data() {
    return {
      form: {},
      file: [],
      formValues: "",
      removeItems: [],
      fileLoading: false,
      company: {},
      password: {}
    };
  },
  methods: {
    fileChange(file) {
      const formData = new FormData();
      formData.append("csvUpload", file);
      const formValues = formData;
      this.file = file;
    },
    deleteUrl(item) {
      this.removeItems.push(item);
    },
    deleteFile(index, item) {
      const tempFiles = [...this.file];
      tempFiles.splice(index, 1);
      this.file = [...tempFiles];
    },
    changeLogo(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.$store.dispatch("Auth/updateLogo", this.file).then(() => {
        this.$bvModal.hide("add-logo");
      });
    },
    previewURL(items, removeItems) {
      return items.filter(x => !removeItems.includes(x));
    },
    updateCompany() {
      this.$store.dispatch("Auth/updateCompany", this.company);
    },
    changePassword() {
      if (this.password.new === this.password.confirm) {
        return this.$store.dispatch("Auth/changePassword", this.password.new);
      }
    },
    preFillFields() {
      this.company = {
        name: this.userProfile.company_name,
        email: this.userProfile.email,
        number: this.userProfile.number,
        address: this.userProfile.address,
        username: this.userProfile.username
      };
    }
  },
  computed: {
    progress() {
      return this.$store.state.Menu.uploadValue;
    },
    userProfile() {
      return this.$store.state.Auth.userProfile;
    },
    updatingCompany() {
      return this.$store.state.Auth.updatingCompany;
    },
    updatingPassword() {
      return this.$store.state.Auth.updatingPassword;
    }
  },
  watch: {
    userProfile: {
      handler: function() {
        this.preFillFields();
      },
      immediate: true
    }
  },
  mounted() {
    //this.preFillFields()
  }
};
</script>
<style >
.card-sections {
  background: #ffffff;
  border-radius: 4px;
  padding: 30px;
  margin-top: 24px;
}

.card-titles {
  font-size: 18px;
  font-weight: 600;
  margin: 0px;
}

.delete-account {
  margin-top: 24px;
}

.delete-btn {
  color: red !important;
  padding: 0 !important;
}

.upload-section {
  display: grid;
  grid-template-columns: 100px 1fr;
  grid-gap: 16px;
}

.buttons-holder {
  display: grid;
  
}

.sub-text {
  font-size: 12px;
  margin-bottom: 5px;
}

img.logo-img {
  border-radius: 50%;
}
</style>
